import type { TabItem } from "@/components/Base/BaseTab/BaseTab.vue";

interface Props {
  modelValue: string;
}

export const useTabAccessibility = (props: Props) => {
  const getTabAttributes = (tab: TabItem) => ({
    "aria-selected": props.modelValue === tab.value,
    "aria-controls": `panel-${tab.value}`,
    tabindex: props.modelValue === tab.value ? 0 : -1,
    role: "tab",
  });

  return {
    getTabAttributes,
  };
};
